import React from 'react';
import { StyledBox, StyledSpinner } from './styles';

function Loading() {
  return (
    <StyledBox>
      <StyledSpinner />
    </StyledBox>
  );
}

export default Loading;
